'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokenHandler = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _api = require('./api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REFRESH_AGE = 315360000000; /* eslint-disable camelcase */
/* eslint-disable no-console */

var getDomain = function getDomain() {
  return {
    development: 'localhost',
    production: 'www.surfline.com',
    staging: 'staging.surfline.com',
    sandbox: 'sandbox.surfline.com'
  }[process.env.NODE_ENV || 'development'];
};

var logger = console.log;
var defaultlogger = {
  info: function info(msg) {
    return logger(msg);
  },
  debug: function debug(msg) {
    return logger(msg);
  },
  error: function error(msg) {
    return logger(msg);
  }
};

var getCookieConfig = function getCookieConfig(req) {
  var expires = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 86400 * 365 * 1000;
  return {
    path: '/',
    domain: '.' + getDomain(),
    expires: new Date(new Date().getTime() + expires)
  };
};

/**
 * Express middleware to handle token-related requests and cookies.
 *
 * @returns modified request and cookies on response, if appropriate
 */

var tokenHandler = exports.tokenHandler = function tokenHandler(authService) {
  var log = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultlogger;
  return function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(req, res, next) {
      var _req$cookies, access_token, refresh_token, valid, refreshedToken, domain;

      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              req.userId = null;
              // check that the access token is valid

              if (!req.cookies.access_token) {
                _context.next = 45;
                break;
              }

              _req$cookies = req.cookies, access_token = _req$cookies.access_token, refresh_token = _req$cookies.refresh_token;
              valid = null;
              _context.prev = 4;
              _context.next = 7;
              return (0, _api.validateToken)(access_token, authService);

            case 7:
              valid = _context.sent;
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              valid = null;
              log.info('tokenHandler: exception occured for validateToken ', _context.t0.toString());

            case 14:
              if (valid) {
                _context.next = 44;
                break;
              }

              _context.prev = 15;
              _context.next = 18;
              return (0, _api.doRefreshToken)(refresh_token, authService);

            case 18:
              refreshedToken = _context.sent;
              _context.next = 21;
              return (0, _api.validateToken)(refreshedToken.access_token, authService);

            case 21:
              valid = _context.sent;

              req.userId = valid;
              log.info('tokenHandler: doRefreshToken response ', refreshedToken);
              res.cookie('access_token', refreshedToken.access_token, getCookieConfig(req, parseInt(refreshedToken.expires_in, 10)));
              res.cookie('refresh_token', refreshedToken.refresh_token, getCookieConfig(req, REFRESH_AGE));
              req.cookies.access_token = refreshedToken.access_token;
              req.cookies.refresh_token = refreshedToken.refresh_token;
              _context.next = 42;
              break;

            case 30:
              _context.prev = 30;
              _context.t1 = _context['catch'](15);
              domain = getDomain();

              log.error({
                err: _context.t1.toString(),
                valid: valid,
                domain: domain,
                cookies: (0, _stringify2.default)(req.cookies),
                message: 'tokenHandler: exception occured while refreshing tokens'
              });
              res.clearCookie('access_token', { path: '/', domain: domain });
              res.clearCookie('refresh_token', { path: '/', domain: domain });
              res.clearCookie('access_token', { path: '/', domain: '.' + domain });
              res.clearCookie('refresh_token', { path: '/', domain: '.' + domain });
              req.cookies.access_token = undefined;
              req.cookies.refresh_token = undefined;
              // TODO remove this post CF deprecation
              // trying to clear our environment specific tokens that CF sets
              res.clearCookie('access_token', { path: '/', domain: '.' + process.env.NODE_ENV + '.surfline.com' });
              res.clearCookie('refresh_token', { path: '/', domain: '.' + process.env.NODE_ENV + '.surfline.com' });

            case 42:
              _context.next = 45;
              break;

            case 44:
              req.userId = valid;

            case 45:
              return _context.abrupt('return', next());

            case 46:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[4, 10], [15, 30]]);
    }));

    return function (_x3, _x4, _x5) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.default = tokenHandler;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/tokenHandler/tokenHandler.js
// module id = 723
// module chunks = 11